/* eslint no-bitwise: ["error", { "allow": ["<<"] }] */
export default class CommonUtils {
    static EMPTY_FUNCTION = () => {};

    static generateKey = () => (Math.random() * 0xFFFFFF << 0).toString(16)

    static createPointer = (className, objectId) => ({
        __type: 'Pointer',
        className,
        objectId
    });

    static formatDate = (date, format = 'yyyy-mm-dd') => {
        if (!date) return '';
        
        const dateObj = date instanceof Date ? date : new Date(date);
        
        if (isNaN(dateObj.getTime())) return '';
        
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        
        switch (format) {
            case 'yyyy':
                return `${year}`;
            case 'yyyy-mm':
                return `${year}-${month}`;
            case 'yyyy-mm-dd':
            default:
                return `${year}-${month}-${day}`;
        }
    }
}
